import React from "react";
import { Building2, ChevronDown } from "lucide-react";

const Organogram = () => {
    const orgData = {
        registrar: "REGISTRAR OF COOPERATIVE SOCIETIES",
        ar: [
            {
                code: "AR(CA)",
                jr: [
                    {
                        code: "JR(CC)",
                        dr: ["DR(CC)", "DR(PDS)"]
                    }
                ]
            },
            {
                code: "AR(F &B)",
                jr: [
                    {
                        code: "JR(FnB)",
                        dr: ["PA to RCS", "DR(Banking)", "DR(PMCP)"]
                    }
                ]
            },
            {
                code: "AR(B &P)",
                jr: [
                    {
                        code: "JR(LO)",
                        dr: ["DR(Union)", "DR(LO)"]
                    },
                    {
                        code: "FA&CAO",
                        dr: []
                    }
                ]
            },
            {
                code: "AR(MPD)",
                jr: [
                    {
                        code: "JR(SnT)",
                        dr: ["DR(CMS)", "DR(Statutory)"]
                    }
                ]
            },
            {
                code: "AR(CE)",
                jr: [
                    {
                        code: "JR(SnT)",
                        dr: ["DR(CE)"]
                    }
                ]
            },
            {
                code: "AR/MD(UBF)",
                jr: [
                    {
                        code: "JR(LO)",
                        dr: ["DR(UB)"]
                    }
                ]
            }
        ]
    };

    return (
        <div className="pt-6 pb-12">
            <div className="max-w-[98%] mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-4">
                    <div className="inline-flex items-center justify-center gap-3 mb-4">
                        <Building2 className="w-10 h-10 text-[#1e40af]" />
                        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800">
                            Organizational Structure
                        </h2>
                    </div>
                    <div className="w-28 h-1.5 bg-[#1e40af] mx-auto mb-3"></div>
                    <p className="text-gray-600 text-base font-medium">Hierarchical Structure of the Department</p>
                </div>

                <div className="bg-white shadow-2xl border-t-4 border-[#1e40af] overflow-hidden">
                    <div className="p-10 md:p-14 bg-gray-50">

                        {/* Registrar */}
                        <div className="flex flex-col items-center mb-12">
                            <div className="bg-gradient-to-r from-[#1e40af] to-[#3b82f6] text-white px-12 py-5 rounded-lg shadow-xl border-2 border-[#1e3a8a] transform hover:scale-105 transition-transform duration-300">
                                <p className="font-bold text-2xl text-center">{orgData.registrar}</p>
                            </div>
                            <div className="flex flex-col items-center my-5">
                                <div className="w-1 h-14 bg-[#1e40af]"></div>
                                <ChevronDown className="w-7 h-7 text-[#1e40af]" />
                            </div>
                        </div>

                        {/* AR Level */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-8 mb-10">
                            {orgData.ar.map((ar, idx) => (
                                <div key={idx} className="flex flex-col items-center">
                                    <div className="w-full bg-gradient-to-br from-[#7c3aed] to-[#a78bfa] rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-[#6d28d9]">
                                        <div className="p-5">
                                            <div className="bg-white/20 backdrop-blur-sm rounded px-4 py-2">
                                                <p className="font-bold text-base text-center text-white">{ar.code}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {ar.jr.length > 0 && (
                                        <div className="flex flex-col items-center my-4">
                                            <div className="w-1 h-8 bg-[#1e40af]"></div>
                                            <div className="w-3 h-3 rounded-full bg-[#1e40af]"></div>
                                        </div>
                                    )}

                                    {ar.jr.length > 0 && (
                                        <div className="w-full">
                                            {/* JR Level - Horizontal Row */}
                                            <div className="flex flex-row gap-3 justify-center mb-4">
                                                {ar.jr.map((jr, jrIdx) => (
                                                    <div key={jrIdx} className="bg-gradient-to-br from-[#0891b2] to-[#06b6d4] rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-[#0e7490] max-w-[160px]">
                                                        <div className="p-4">
                                                            <div className="bg-white/25 backdrop-blur-sm rounded px-3 py-1">
                                                                <p className="font-semibold text-sm text-center text-white">{jr.code}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* DR Level - Below All JR Boxes */}
                                            <div className="flex flex-col gap-4">
                                                {ar.jr.map((jr, jrIdx) => (
                                                    jr.dr.length > 0 && (
                                                        <div key={jrIdx} className="flex flex-col items-center">
                                                            <div className="flex flex-col items-center my-3">
                                                                <div className="w-0.5 h-7 bg-[#0891b2]"></div>
                                                                <div className="w-2 h-2 rounded-full bg-[#06b6d4]"></div>
                                                            </div>

                                                            <div className="w-full flex flex-wrap gap-3 justify-center">
                                                                {jr.dr.map((dr, drIdx) => (
                                                                    <div
                                                                        key={drIdx}
                                                                        className="bg-gradient-to-br from-[#10b981] to-[#34d399] px-4 py-2 rounded shadow hover:shadow-md transition-all duration-200 border border-[#059669] hover:border-[#047857] transform hover:-translate-y-0.5"
                                                                    >
                                                                        <p className="font-medium text-xs text-center whitespace-nowrap text-white">
                                                                            {dr}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="mt-6 text-center">
                            <p className="text-sm text-gray-500 italic">
                                * Organizational structure as per current administrative setup
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Organogram;